import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  thumbnail?: string;
  onLoad?: () => void;
}
export function LazyImage({
  src,
  alt,
  className = '',
  thumbnail,
  onLoad
}: LazyImageProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    if (!imgRef.current) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '50px' // Start loading 50px before image enters viewport
    });
    observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, []);
  const handleLoad = () => {
    setIsLoaded(true);
    onLoad?.();
  };
  return <div ref={imgRef} className={`relative overflow-hidden ${className}`} data-id="element-107">
      {/* Thumbnail/placeholder */}
      {!isLoaded && <motion.div initial={{
      opacity: 1
    }} animate={{
      opacity: isLoaded ? 0 : 1
    }} className="absolute inset-0 bg-neutral-900" data-id="element-108">
          {thumbnail ? <img src={thumbnail} alt={alt} className="w-full h-full object-cover blur-sm scale-110" data-id="element-109" /> : <div className="w-full h-full flex items-center justify-center" data-id="element-110">
              <motion.div animate={{
          opacity: [0.3, 0.6, 0.3]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="w-12 h-12 border-2 border-white/20 border-t-white/60 rounded-full" style={{
          animation: 'spin 1s linear infinite'
        }} data-id="element-111" />
            </div>}
        </motion.div>}

      {/* Actual image */}
      {isInView && <motion.img src={src} alt={alt} onLoad={handleLoad} initial={{
      opacity: 0
    }} animate={{
      opacity: isLoaded ? 1 : 0
    }} transition={{
      duration: 0.3
    }} className={`w-full h-full object-cover ${className}`} data-id="element-112" />}
    </div>;
}